<template>
	<div class="VideoIndexBox">
		<div class="common-header-wrap">
			<mt-header class="common-header" title="Video Page">
				<mt-button icon="back" slot="left" @click="backoff()"></mt-button>	
				 <mt-button slot="right" @click="godarenman" v-show="darenindex">My DYP Video Page</mt-button>
			</mt-header>
		</div>
		<div class="noisman" v-if="noisman">
			<p>You are not DYP Video uploader yet.</p>
			<button class="manbutton" @click="becomeman">Become a DYP Video uploader.</button>
			<button class="manbutton govideos" @click="govideolist">Video Channel</button>
		</div>
		
		<div class="manContente" v-if="noismancontent">
			
		
			<div class="user-headerbox">
				<div class="user-avatar iconfont">
			        <img :src="manimg">
			        <i v-show="iconfonts" class="item-icon iconfont">&#xe639;</i>
			        <input @change="uploadImage($event)" type="file" ref="file" accept="image/*">
			    </div>
			    <div class="inputlist">
			    	<div class="inputbox">
			    		<div class="inputboxspan">
			    			<span>Username</span>
			    		</div>
			    		<div class="inputboxval">
			    			<input v-model="svideoman_name" type="text"  placeholder="Username"/>
			    		</div>
			    	</div>
			    	
			    	<div class="inputbox">
			    		<div class="inputboxspan">
			    			<span>Bio</span>
			    		</div>
			    		<div class="inputboxval">
			    			<textarea placeholder="Bio" v-model="self_intro"></textarea>
			    		</div>
			    	</div>
			    	
			    	<!--<div class="inputbox">
			    		<div class="inputboxspan">
			    			<span>关联店铺(选填)</span>
			    		</div>
			    		<div class="inputboxval">
			    			<input class="store_ids" type="text" v-model="store_id" placeholder="请输入店铺链接如https://h5.duoyp.com/home/storedetail?id=xxx"/>
			    		</div>
			    	</div>-->
			    </div>
			</div>
			
			<div class="ismaobotton">
				<span @click="subman">Submit</span>
			</div>
		</div>
	</div>
</template>

<script>
	import { getisVideoMan,getsumVideoMan} from '../../../api/video'
	import { mapState } from 'vuex'
	import { Toast } from 'mint-ui'
export default {
  name: 'video_index',
  data () {
    return {
      svideoman_id:"",
      member_id:"",
      svideoman_name:"",
      self_intro:"",
      store_id:"",
      manimg:"https://www.duoyp.com/uploads/home/common/default_goods_image.jpg",
      noisman:false,
      noismancontent:false,
      darenindex:false,
      iconfonts:true,
    }
  },
  
  components: {
    
  },
  mounted () {
	
  },
  created: function () {

  	if(this.user){
  		this.member_id=this.user.member_id;
		getisVideoMan(this.member_id,this.token).then((res) => {
			if(res.result.isman>0){
				this.darenindex=true;
				this.noismancontent=true;
				this.svideoman_name=res.result.man_info.svideoman_name;
				this.self_intro=res.result.man_info.self_intro;
				this.manimg=res.result.man_info.svideoman_pic;
				this.iconfonts=false;
				this.svideoman_id=res.result.man_info.svideoman_id;
				if(res.result.man_info.store_id && res.result.man_info.store_id!=0){
					var urls = window.location.protocol+"//"+window.location.host;
					this.store_id=urls+"/home/storedetail?id="+res.result.man_info.store_id;
				}
				
			}else{
				this.noisman=true;
			}
	   	})
  	}
   
  },
  computed: {
    ...mapState({
    	isOnline: state => state.member.isOnline,
    	user: state => state.member.info,
    	token: state => state.member.token
    })
  },
  methods: {
  	//我要成为达人
  	becomeman:function(){
  		this.noisman=false;
  		this.noismancontent=true;
  	},
  	uploadImage(e){
      //上传图片并预览
      let file = e.target.files[0];
      let img = new FileReader();
      img.readAsDataURL(file);
      img.onload = ({ target }) => {
        this.manimg = target.result;
      };
   },
   //提交
	subman:function(){
		if(this.svideoman_name==""){
			Toast("Username");
		}else{
			const file = this.$refs.file.files[0]
	      	const param = new FormData()
	      	param.append('videoman', file);
	      	param.append('svideoman_id', this.svideoman_id);
	      	param.append('svideoman_name', this.svideoman_name);
	      	param.append('self_intro', this.self_intro);
	      	param.append('store_id', this.store_id);
	      	param.append('member_id', this.member_id);
	      	param.append('key', this.token);
			getsumVideoMan(param).then((res) => {
				if(res.code==10000){
					getisVideoMan(this.member_id,this.token).then((res) => {
						if(res.result.isman>0){
							this.svideoman_id=res.result.man_info.svideoman_id;
							this.$router.push({ name: 'HomeVideoIndex', query: { svideoman_id: this.svideoman_id } })
						}
				   	})
				}else{
					Toast("Save failed")
				}
				
		   	}).catch(function (error) {
		        Indicator.close()
		        Toast(error.message)
		    })
		}
	},
	govideolist:function(){
		this.$router.push({ name: 'HomeVideoList'})
	},
	godarenman:function(){
		this.$router.push({ name: 'HomeVideoIndex', query: { svideoman_id: this.svideoman_id } })
	},
	//返回上一页
   backoff:function(){
   	var gologin=this.$route.query.gologin;
   	if(gologin && gologin!=undefined){
   		this.$router.push({ name: 'MemberIndex' })
   	}else{
   		this.$router.go(-1);
   	}
   },
  }
}		
</script>

<style lang="scss" scoped>
.noisman{padding: 5rem 0;text-align: center;}
.noisman p{font-size: 0.8rem;color: #666;line-height: 1.3rem;text-align: center;}
.manbutton{display: inline-block;border: none;line-height: 1.6rem;padding: 0.3rem 3rem;font-size: 0.8rem;color: #fff;background: #e93b3d;margin-top: 2rem;border-radius: 5px;}
.user-avatar{width: 5rem;height: 5rem;margin: 1rem auto;position: relative;overflow: hidden;line-height: 4.9rem;border: 1px solid #d9d9d9;text-align: center;}
.user-headerbox{}
.user-avatar img{max-width: 100%;max-height: 100%;}
.user-avatar input{position: absolute;left: 0px;top: 0px;width: 100%;height: 100%;z-index: 9;opacity: 0;}
.user-avatar i{position: absolute;z-index: 10;width: 1rem;height: 1rem;left: 50%;top: 50%;margin-left: -0.5rem;margin-top: -0.5rem;line-height: 1rem;}
.user-headerbox .mint-field-core{font-size: 0.55rem;}
.inputlist{padding: 0 0.3rem;background: #fff;}
.inputbox {border-bottom: 1px solid #d9d9d9;padding: 0.3rem 0 0.2rem 0;}
.inputboxspan{display: inline-block;vertical-align: top;width: 5rem;}
.inputboxspan span{font-size: 0.7rem;color: #333;line-height: 1.5rem;}
.inputboxval{display: inline-block;vertical-align: top;width: calc(100% - 5.5rem);display: inline-block;}
.inputboxval input{line-height: 1.5rem;font-size: 0.7rem;color: #333;display: inline-block;width: 100%;outline: none;border: none;}
.inputboxval input.store_ids{font-size: 0.3rem;}
.inputboxval textarea{line-height: 1.3rem;font-size: 0.7rem;color: #333;display: inline-block;width: 100%;outline: none;border: none;height: 5rem;resize: none;font-family: "微软雅黑";}
.ismaobotton{text-align: center;}
.ismaobotton span{display: inline-block;border: none;line-height: 1.6rem;padding: 0.3rem 3rem;font-size: 0.8rem;color: #fff;background: #e93b3d;margin-top: 2rem;border-radius: 5px;min-width: 80%;box-sizing: border-box;}
.govideos{background-color: #d1d1d1;margin-top: 1rem;color: #888;}
</style>